<template>
  <div class="interaction-message container">
    <hr>
    <h3>{{ question.el_Text }}</h3>
    <div class="quill-editor" ref="quillEditor"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import Quill from 'quill';

const emit = defineEmits(['interaction-started']);
const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  testData: {
    type: Object,
    required: true,
  },
});

const quillEditor = ref(null);
let quillInstance = null;

// Ajuster dynamiquement la hauteur du conteneur Quill
const adjustQuillHeight = () => {
  if (quillInstance) {
    const contentHeight = quillInstance.root.scrollHeight;
    quillEditor.value.style.overflow = 'hidden';
  }
};

// Initialisation de Quill
onMounted(() => {
  if (quillEditor.value) {
    quillInstance = new Quill(quillEditor.value, {
      theme: 'snow',
      readOnly: true,
      modules: {
        toolbar: false,
      },
    });

    if (props.question?.el_RichText) {
      quillInstance.root.innerHTML = props.question.el_RichText;
    }

    adjustQuillHeight();
  }
});

// Observer les changements de el_RichText
watch(
  () => props.question?.el_RichText,
  (newValue) => {
    if (quillInstance && newValue !== quillInstance.root.innerHTML) {
      quillInstance.root.innerHTML = newValue || '';
      adjustQuillHeight();
    }
  }
);
</script>

<style scoped>
.interaction-message {
  margin: 1em 0;
}

.quill-editor {
  min-height: max-content !important;
  height: auto !important;
  border: 1px solid #ccc;
  overflow: hidden !important;
  transition: height 0.3s ease;
}

/* Cacher l'élément clipboard de Quill */
.quill-editor :deep(.ql-clipboard) {
  display: none !important;
}
</style>
